import { render } from "./TopButton.vue?vue&type=template&id=794af49e&scoped=true"
import script from "./TopButton.vue?vue&type=script&lang=js"
export * from "./TopButton.vue?vue&type=script&lang=js"

import "./TopButton.vue?vue&type=style&index=0&id=794af49e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794af49e"]])

export default __exports__